/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CarrierRowField {
  isZorroAppointed = 'isZorroAppointed',
  isPdfApplicationAvailable = 'isPdfApplicationAvailable',
  isDocumentsRequired = 'isDocumentsRequired',
  websiteUrl = 'websiteUrl',
  phoneNumber = 'phoneNumber',
  providerSearchUrl = 'providerSearchUrl',
  medicationSearchUrl = 'medicationSearchUrl',
  initialPayment = 'initialPayment',
  autoPay = 'autoPay',
  autoPayDate = 'autoPayDate',
  extraSteps = 'extraSteps',
  specialRequestsElectionSubmitted = 'specialRequestsElectionSubmitted',
  specialRequestsCarrierAppSent = 'specialRequestsCarrierAppSent',
  echoCode = 'echoCode',
  paymentMethod = 'paymentMethod',
}
